import { useRef } from 'react';

import ReactToPrint from 'react-to-print';
import { FcPrint } from 'react-icons/fc';
import { QRCodeCanvas } from 'qrcode.react';
import styled, { css } from 'styled-components';

export type LocationToPrint = {
    datamatrix: string;
};

export const PrintLocationTags = ({ locationsToPrint }: { locationsToPrint: LocationToPrint[] }) => {
    const componentRef = useRef(null);
    const isDisabled = !locationsToPrint.length;

    return (
        <Container>
            <ReactToPrint
                trigger={() => (
                    <ActionButton $disabled={isDisabled}>
                        <ActionIcon>
                            <FcPrint size={22} />
                        </ActionIcon>
                        <ActionLabel>Imprimer ({locationsToPrint.length})</ActionLabel>
                    </ActionButton>
                )}
                content={() => componentRef.current}
            />
            <HiddenComponent>
                <Printable ref={componentRef}>
                    <LocationTags>
                        {locationsToPrint.map((location, index) => {
                            const { datamatrix } = location;

                            return (
                                <LocationTagContainer key={index}>
                                    <QRCodeContainer>
                                        <QRCodeCanvas value={datamatrix} size={150} />
                                    </QRCodeContainer>
                                    <DatamatrixLabel>{datamatrix}</DatamatrixLabel>
                                </LocationTagContainer>
                            );
                        })}
                    </LocationTags>
                </Printable>
            </HiddenComponent>
        </Container>
    );
};

const Container = styled.div``;

const ActionButton = styled.button<{ $disabled?: boolean }>`
    display: flex;
    flex: 1;
    align-items: center;
    border-radius: ${({ theme }) => theme.borderRadius};
    padding: 5px;
    cursor: pointer;
    border: none;
    background: transparent;

    &:hover {
        background-color: ${({ theme }) => theme.overlayColor};
    }

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.4;
            cursor: default;
            pointer-events: none;
        `}
`;

const ActionIcon = styled.div`
    flex-shrink: 0;
    height: 22px;
`;

const ActionLabel = styled.div`
    font-size: 18px;
    color: ${({ theme }) => theme.ctaPrimaryColor};
    margin-left: 5px;
`;

const HiddenComponent = styled.div`
    display: none;
`;

const Printable = styled.div`
    @page {
        size: portrait;
        margin: 10mm;
    }
`;

const LocationTags = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

const LocationTagContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 33.33%;
    padding: 15px;
    border: 1px solid black;
    min-height: 220px;
    break-inside: avoid;
    box-sizing: border-box;
`;

const QRCodeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: white;
`;

const DatamatrixLabel = styled.span`
    font-size: 24px;
    font-weight: 800;
    color: black;
    text-align: center;
    margin-top: 10px;
`;
